import(/* webpackMode: "eager" */ "/home/runner/work/website-dominikakrata/website-dominikakrata/src/app/page.tsx")